import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaBullhorn, FaPlus, FaTrash, FaList, FaUser, FaCalendar } from "react-icons/fa";
import $ from "jquery";

import Pagination from "Components/Pagination";
import NoticeDetail from "Components/NoticeDetail";
import NoticeWrite from "Components/NoticeWrite";
import CommonModal from "Components/CommonModal";
import { catchError, changeState, commonModalSetting } from "JS/common";
import { getNoticeList, noticeDelete } from "JS/API";

import { commonStyles, designTokens, listPageStyles } from "utils/designSystem";
import { TableCell, TableContainer, TableHeader, Table } from "Components/UI/Table";
import PageContainer from "Components/UI/PageContainer";
import Select from "Components/UI/Select";
import Button from "Components/UI/Button";

const Notice = () => {
  const navigate = useNavigate();
  const [pageInfo, setPageInfo] = useState({
    page: 1,
    totalPage: 1,
    limit: 10,
  });
  const [id, setId] = useState("");
  const [modal, setModal] = useState(false);
  const [editor, setEditor] = useState(false);
  const [noticeList, setNoticeList] = useState([]);
  const [idArr, setIdArr] = useState([]);
  const [alert, setAlert] = useState("");
  const [alertBox, setAlertBox] = useState({
    mode: "",
    context: "",
    bool: false,
  });

  let prevent = false;

  // 추가 스타일 (디자인 시스템 보완)
  const pageStyles = {
    controlBar: {
      ...commonStyles.card,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: designTokens.spacing.lg,
      marginBottom: designTokens.spacing.lg
    },
    actionGroup: {
      display: 'flex',
      alignItems: 'center',
      gap: designTokens.spacing.md
    },
    noDataContainer: listPageStyles.noDataContainer,
    titleCell: {
      fontWeight: '500',
      color: designTokens.colors.text.primary,
      cursor: 'pointer'
    },
    checkboxContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    checkbox: listPageStyles.checkbox};

  // 서비스 코드에 따른 배지 variant 결정

  //= 공지사항 목록 불러오기
  const getNotice = async () => {
    if (prevent) return;
    prevent = true;
    setTimeout(() => {
      prevent = false;
    }, 200);
    const result = await getNoticeList(pageInfo.page, pageInfo.limit);
    if (typeof result === "object") {
      setNoticeList(result?.data?.data);
      changeState(setPageInfo, "totalPage", result?.data?.meta?.total_page);
    } else return await catchError(result, navigate, setAlertBox, setAlert);
  };

  //= 공지사항 다중 삭제
  const deleteNotices = async () => {
    const data = idArr;
    const result = await noticeDelete({ notice_ids: data });
    if (typeof result === "object") {
      commonModalSetting(setAlertBox, true, "alert", "삭제되었습니다.");
      $(".notice-all-check").prop("checked", false);
      $(".notice-check").prop("checked", false);
      changeState(setPageInfo, "page", 1);
      setIdArr([]);
      setAlert("completeDelete");
      commonModalSetting(
        setAlertBox,
        true,
        "alert",
        "정상적으로 삭제되었습니다."
      );
      getNotice();
    } else return await catchError(result, navigate, setAlertBox, setAlert);
  };

  //= 전체 선택
  const checkAll = () => {
    let arr = [];
    if ($(".notice-all-check").is(":checked")) {
      $(".notice-check").prop("checked", true);
      const all = $(".notice-check").length;
      for (let i = 0; i < all; i++) {
        const val = document.getElementsByClassName("notice-check")[i].value;
        arr.push(val);
        setIdArr(arr);
      }
    } else {
      $(".notice-check").prop("checked", false);
      setIdArr([]);
    }
  };

  //= 개별 선택
  const checkEach = () => {
    let all = $(".notice-check").length;
    let checked = $(".notice-check:checked").length;
    let arr = [];
    if (all !== checked) $(".notice-all-check").prop("checked", false);
    else $(".notice-all-check").prop("checked", true);
    for (let i = 0; i < all; i++) {
      if (document.getElementsByClassName("notice-check")[i].checked) {
        const val = document.getElementsByClassName("notice-check")[i].value;
        arr.push(val);
        setIdArr(arr);
      }
    }
  };

  //= 공지사항 목록 렌더
  const renderTableBody = () => {
    return noticeList?.map(({ title, created_at, service_code, id, admin_name }) => {
      //& 목록 클릭 시 실행할 함수
      const onModal = () => {
        setModal(true);
        setId(id);
      };

      return (
        <tr key={id}>
          <TableCell style={pageStyles.checkboxContainer} onClick={(e) => e.stopPropagation()}>
            <label style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
              <input
                type="checkbox"
                className="notice-check"
                onChange={checkEach}
                value={id}
                style={pageStyles.checkbox}
              />
            </label>
          </TableCell>

          <TableCell onClick={onModal}>
            <div style={pageStyles.titleCell}>{title}</div>
          </TableCell>

          <TableCell onClick={onModal}>
            <div style={{ display: 'flex', alignItems: 'center', gap: designTokens.spacing.xs }}>
              <FaCalendar size={12} style={{ color: designTokens.colors.text.tertiary }} />
              {created_at.split("T")[0]}
            </div>
          </TableCell>

          <TableCell onClick={onModal}>
            <div style={{ display: 'flex', alignItems: 'center', gap: designTokens.spacing.xs }}>
              <FaUser size={12} style={{ color: designTokens.colors.text.tertiary }} />
              {admin_name}
            </div>
          </TableCell>
        </tr>
      );
    });
  };

  useEffect(() => {
    document.title = "마크픽 관리자 > 공지사항 관리";
  }, []);

  useEffect(() => {
    if (!modal || !editor) getNotice();
  }, [pageInfo.page, pageInfo.limit, modal, editor]);

  return (
    <PageContainer 
      title="NOTICE" 
      icon={<FaBullhorn />}
    >
      {/* 컨트롤 바 */}
      <div style={pageStyles.controlBar}>
        <div style={pageStyles.actionGroup}>
          <FaList size={16} style={{ color: designTokens.colors.text.tertiary }} />
          <Select
            value={pageInfo.limit}
            onChange={(e) => {
              setPageInfo((prev) => {
                const clone = { ...prev };
                clone.page = 1;
                clone.limit = e.target.value;
                return clone;
              });
            }}
            style={{ minWidth: '140px' }}
          >
            <option value="10">10개씩 보기</option>
            <option value="30">30개씩 보기</option>
            <option value="50">50개씩 보기</option>
          </Select>
        </div>

        <div style={pageStyles.actionGroup}>
          <Button
            variant="success"
            icon={<FaPlus />}
            onClick={() => {
              setEditor(true);
              setId("");
            }}
          >
            글쓰기
          </Button>
          
          <Button
            variant="danger"
            icon={<FaTrash />}
            onClick={() => {
              if (!idArr.length)
                return commonModalSetting(
                  setAlertBox,
                  true,
                  "alert",
                  "삭제할 글을 선택해 주세요."
                );
              else {
                setAlert("deleteConfirm");
                commonModalSetting(
                  setAlertBox,
                  true,
                  "confirm",
                  "글을 삭제하면 다시 복구할 수 없습니다.<br/>정말 삭제하시겠습니까?"
                );
              }
            }}
          >
            삭제
          </Button>
        </div>
      </div>

      {/* 테이블 또는 빈 상태 */}
      {noticeList?.length ? (
        <TableContainer>
          <Table>
            <thead>
              <tr>
                <TableHeader>
                  <div style={pageStyles.checkboxContainer}>
                    <label style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                      <input
                        type="checkbox"
                        className="notice-all-check"
                        onChange={checkAll}
                        style={pageStyles.checkbox}
                      />
                    </label>
                  </div>
                </TableHeader>
                <TableHeader>제목</TableHeader>
                <TableHeader>등록일</TableHeader>
                <TableHeader>작성자</TableHeader>
              </tr>
            </thead>
            <tbody>{renderTableBody()}</tbody>
          </Table>
        </TableContainer>
      ) : (
        <div style={pageStyles.noDataContainer}>
          <FaBullhorn 
            size={48} 
            style={{ 
              color: designTokens.colors.text.muted, 
              marginBottom: designTokens.spacing.md 
            }} 
          />
          <div style={{ fontSize: '18px', fontWeight: '500', marginBottom: designTokens.spacing.xs }}>
            공지사항이 없습니다
          </div>
          <div style={{ fontSize: '14px' }}>
            새로운 공지사항을 작성해보세요.
          </div>
        </div>
      )}

      <Pagination pageInfo={pageInfo} setPageInfo={setPageInfo} />

      {/* 모달들 */}
      {modal && (
        <NoticeDetail noticeId={id} setModal={setModal} setEditor={setEditor} />
      )}
      {editor && (
        <NoticeWrite id={id} setModal={setModal} setEditor={setEditor} />
      )}
      {alertBox.bool && (
        <CommonModal
          setModal={setAlertBox}
          modal={alertBox}
          okFn={() => {
            if (alert === "deleteConfirm") deleteNotices();
            else if (alert === "completeDelete") getNotice();
            else if (alert === "logout") navigate("/");
            else return;
          }}
        />
      )}
    </PageContainer>
  );
};

export default Notice;